// @ts-nocheck
import { storeService } from '@/services';
export default {
    /**
     * 상점 등록
     */
    async postStore({ rootGetters }, payload) {
        try {
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            const formData = {
                hubId,
                ...payload,
            };
            await storeService.postStore(formData);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            console.log('[postStore] ', message, reason);
            return {
                isSuccess: false,
                message,
                reason,
            };
        }
    },
};
